module.exports = __webpack_public_path__ + "img/domains-step-2.en.dbea6bc9.png";